import React from 'react'
import { Row, Col, Tab } from 'react-bootstrap'

const PatientActivity: React.FC = () => {
  return (
    <Tab.Pane eventKey="fourth">
      <Row>
        <Col>
          <div className="timeline mt-3 me-2">
            <p className="text-muted mb-0">No activity yet</p>
          </div>
        </Col>
      </Row>
    </Tab.Pane>
  )
}

export default PatientActivity
